module.exports = {"TXTWCL_Convert_Funds":{"id":"TXTWCL_Convert_Funds","defaultMessage":"Convertir des fonds","track":"Convert Funds"}}